import { Component, Inject, OnInit } from '@angular/core';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { AlertService } from 'src/lib/ariadna/alert';
import { Router } from '@angular/router';
import { Utils } from '../../services/utils';

@Component({
    selector: 'app-change-pw',
    templateUrl: './change-pw.component.html',
    styleUrls: ['./change-pw.component.scss'],
    standalone: false,
})
export class ChangePwComponent implements OnInit {
    public frm!: FormGroup;
    public loading = false;

    public hidePasswordOLD = true; // Показывать пароль старый
    public hidePasswordNEW = true; // Показывать пароль новый
    public hidePasswordNEW2 = true; // Показывать пароль новый2
    public exitForm = false; // Форма выхода

    public constructor(
        public dialogRef: MatDialogRef<ChangePwComponent>,
        private auth: AuthService,
        private alertService: AlertService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.dialogRef.disableClose = true; // запрет закрытия окна (только командами)
    }

    public ngOnInit(): void {
        this.initialize();
    }

    /* Инициализация при создании компонента */
    private initialize(): void {
        this.frm = new FormGroup(
            {
                oldPW: new FormControl('', [
                    Validators.required,
                    Validators.minLength(3),
                ]),
                newPW: new FormControl('', [
                    Validators.required,
                    Validators.minLength(3),
                ]),
                new2PW: new FormControl('', [
                    Validators.required,
                    Validators.minLength(3),
                ]),
            },
            { validators: this.passwordMatchValidator },
        );
        this.exitForm = false;
    }

    /* Проверка возможности отправки */
    public testChangePW(): boolean {
        let f = false;
        let newPW = this.frm.get('newPW');
        let newPW2 = this.frm.get('new2PW');
        /*
    if (newPW && newPW2){
      
    }
*/
        if (this.loading == false) {
            if (this.frm.valid == true) {
                if (newPW && newPW2) {
                    if (newPW.value == newPW2.value) {
                        f = true;
                    }
                }
            }
        }
        return f;
    }

    public exit() {
        this.auth.logout();
        this.dialogRef.close();
    }

    public goToChange() {
        this.loading = true;
        let oldPw = this.frm.get('oldPW')?.value;
        let newPw = this.frm.get('newPW')?.value;
        let newPwRep = this.frm.get('new2PW')?.value;

        if (oldPw === newPw) {
            this.alertService.error(
                'Новый пароль должен отличаться от предыдущего!',
                5000,
            );
            this.loading = false;
            return;
        }

        if (oldPw && newPw && newPwRep) {
            this.auth.changepw(oldPw, newPw, newPwRep).subscribe({
                next: (info) => {
                    this.loading = false;
                    this.exitForm = true;
                    this.alertService.info(
                        'Пароль успешно изменен. Пожалуйста, авторизуйтесь с новым паролем.',
                        6000,
                    );
                    this.dialogRef.close();
                    this.exit();
                },
                error: (err: unknown) => {
                    const msg = Utils.getErrorMessage(
                        err,
                        'Ошибка при смене пароля',
                    );
                    if (msg.includes('Действующий пароль введён неверно')) {
                        this.alertService.error(msg, 6000);
                        this.frm
                            .get('oldPW')
                            ?.setErrors({ oldPassInvalid: true });
                        this.loading = false;
                        return;
                    }
                    this.alertService.error(msg, 6000);
                    this.dialogRef.close();
                    this.loading = false;
                },
            });
        }
    }

    public goToRecovery() {
        this.auth.setRecoveryFlag(true);
        this.auth.logout();
    }
    public maskPassword(event: Event, field: string): void {
        const input = event.target as HTMLInputElement;
        const value = input.value;
        const formControl = this.frm.get(field);

        if (formControl) {
            formControl.setValue(value);

            if (
                (field === 'oldPW' && this.hidePasswordOLD) ||
                (field === 'newPW' && this.hidePasswordNEW) ||
                (field === 'new2PW' && this.hidePasswordNEW2)
            ) {
                input.value = '*'.repeat(value.length);
            } else {
                input.value = value;
            }
        }
    }

    public onBlur(field: string): void {
        const control = this.frm.get(field);
        if (control) {
            control.markAsTouched(); // Устанавливает статус "touched"
            control.updateValueAndValidity(); // Обновляет валидацию
        }
    }
    public passwordMatchValidator(
        control: AbstractControl,
    ): ValidationErrors | null {
        const password = control.get('newPW')?.value;
        const passwordRepeat = control.get('new2PW')?.value;

        if (password && passwordRepeat && password !== passwordRepeat) {
            return { passwordMismatch: true };
        }
        return null;
    }
    public checkInput(event: Event, controlName: 'newPW' | 'new2PW'): void {
        const input = event.target as HTMLInputElement;
        const cleanValue = input.value.replace(/\s/g, '');

        this.frm.get(controlName)?.setValue(cleanValue);
    }

    public getErrorMessage(field: string): string {
        const control = this.frm.get(field);
        if (!control) return '';

        if (field === 'new2PW' && control.hasError('mismatch')) {
            return 'Пароли не совпадают';
        }

        if (control.hasError('required')) {
            return 'Это поле обязательно для заполнения';
        }
        if (control.hasError('minlength')) {
            return 'Пароль должен быть не менее 2 символов';
        }

        return '';
    }
}
